export class CommonUtil {

    static CHECKED: string = "Y";
    static UN_CHECKED: string = "N";
    static CREATE_MODE = "create";
    static UPDATE_MODE = "update";

    static IS_ROLES = false;
    static IS_USER_MANAGEMENT = false;

    static ROLES = "Roles";
    static USER_MANAGEMENT = "User Management";
    static DEVICE_MANAGER = "Device Manager";
    static TRUCK_MANAGER = "Truck Manager";
    static TAG_SCHEME_MANAGER = "Tag Scheme Manager";
    static DEVICE_EVENTS = "Device Events Report";
    static DEVICE_STATUS = "Device Status Report";
    static TAG_STATUS = "Tip Push Status Report";
    static TAG_EVENTS_FAILED = "Device Events Failed To Process Report";
    static TAG_EVENTS_MISSING = "Missing Device Event Report";
    static AT_A_GLANCE = "At a Glance";

    static TRUCKS = "TRUCKS";
    static DEVICES = "DEVICES";

    static RECORD_COUNT = 10000;
    static DEVICE_STATUS_COUNT = 10000;
    static TIP_STATUS_COUNT = 10000;
    static MONTHLY_RECORD = 10000;

    static PERMISSION_DATA:any = {};

    static deliveryStatuses:any[] = [{key: "Delivered", value: "Delivered"}, {key: "Delivery In Progress", value: "Delivery In Progress"}, {key: "Delivery Failed", value: "Delivery Failed"}];
    static tipevents:any[] = [{key: "1", value: "Tip"}, {key: "2", value: "Observation"}];
    static events:any[] = [{key: "1", value: "Tip"}, {key: "2", value: "Observation"}, {key: "3", value: "Heartbeat"}];
    static statuses: any[] = [{key: "Active", value: "Active"}, {key: "Inactive", value: "Inactive"}];
    static missingEventTimes: any[] = [{key: "24", value: "Last 24 hours"}, {key: "48", value: "Last 48 hours"}, {key: "168", value: "Last 1 week"}, {key: "360", value: "Last 15 days"}, {key: "2160", value: "Last 3 months"}];
    static headerFormats: any[] = [{key: "ASCII", value: "ASCII"}, {key: "Hexadecimal", value: "Hexadecimal"}];
    static serialFormat: any[] = [{key: "ASCII", value: "ASCII"}, {key: "Hexadecimal", value: "Hexadecimal"}];
    static trcukStatuses: any[] = [{key: "Active", value: "Active"}, {key: "Inactive", value: "Inactive"},{key:'Being Repaired',value:'Being Repaired'}];
    static tagStatuses: any[] = [{key: "Active", value: "Active"}, {key: "Inactive", value: "Inactive"}];

    static timeZones: any[] =[
        {key: "Etc/GMT+12", value: "Etc/GMT+12" },
        {key: "Etc/GMT+11", value: "Etc/GMT+11" },
        {key: "MIT", value: "MIT" },
        {key: "Pacific/Apia", value: "Pacific/Apia" },
        {key: "Pacific/Midway", value: "Pacific/Midway" },
        {key: "Pacific/Niue", value: "Pacific/Niue" },
        {key: "Pacific/Pago_Pago", value: "Pacific/Pago_Pago" },
        {key: "Pacific/Samoa", value: "Pacific/Samoa" },
        {key: "US/Samoa", value: "US/Samoa" },
        {key: "America/Adak", value: "America/Adak" },
        {key: "America/Atka", value: "America/Atka" },
        {key: "Etc/GMT+10", value: "Etc/GMT+10" },
        {key: "HST", value: "HST" },
        {key: "Pacific/Fakaofo", value: "Pacific/Fakaofo" },
        {key: "Pacific/Honolulu", value: "Pacific/Honolulu" },
        {key: "Pacific/Johnston", value: "Pacific/Johnston" },
        {key: "Pacific/Rarotonga", value: "Pacific/Rarotonga" },
        {key: "Pacific/Tahiti", value: "Pacific/Tahiti" },
        {key: "SystemV/HST10", value: "SystemV/HST10" },
        {key: "US/Aleutian", value: "US/Aleutian" },
        {key: "US/Hawaii", value: "US/Hawaii" },
        {key: "Pacific/Marquesas", value: "Pacific/Marquesas" },
        {key: "AST", value: "AST" },
        {key: "America/Anchorage", value: "America/Anchorage" },
        {key: "America/Juneau", value: "America/Juneau" },
        {key: "America/Nome", value: "America/Nome" },
        {key: "America/Yakutat", value: "America/Yakutat" },
        {key: "Etc/GMT+9", value: "Etc/GMT+9" },
        {key: "Pacific/Gambier", value: "Pacific/Gambier" },
        {key: "SystemV/YST9", value: "SystemV/YST9" },
        {key: "SystemV/YST9YDT", value: "SystemV/YST9YDT" },
        {key: "US/Alaska", value: "US/Alaska" },
        {key: "America/Dawson", value: "America/Dawson" },
        {key: "America/Ensenada", value: "America/Ensenada" },
        {key: "America/Los_Angeles", value: "America/Los_Angeles" },
        {key: "America/Tijuana", value: "America/Tijuana" },
        {key: "America/Vancouver", value: "America/Vancouver" },
        {key: "America/Whitehorse", value: "America/Whitehorse" },
        {key: "Canada/Pacific", value: "Canada/Pacific" },
        {key: "Canada/Yukon", value: "Canada/Yukon" },
        {key: "Etc/GMT+8", value: "Etc/GMT+8" },
        {key: "Mexico/BajaNorte", value: "Mexico/BajaNorte" },
        {key: "PST", value: "PST" },
        {key: "PST8PDT", value: "PST8PDT" },
        {key: "Pacific/Pitcairn", value: "Pacific/Pitcairn" },
        {key: "SystemV/PST8", value: "SystemV/PST8" },
        {key: "SystemV/PST8PDT", value: "SystemV/PST8PDT" },
        {key: "US/Pacific", value: "US/Pacific" },
        {key: "US/Pacific-New", value: "US/Pacific-New" },
        {key: "America/Boise", value: "America/Boise" },
        {key: "America/Cambridge_Bay", value: "America/Cambridge_Bay" },
        {key: "America/Chihuahua", value: "America/Chihuahua" },
        {key: "America/Dawson_Creek", value: "America/Dawson_Creek" },
        {key: "America/Denver", value: "America/Denver" },
        {key: "America/Edmonton", value: "America/Edmonton" },
        {key: "America/Hermosillo", value: "America/Hermosillo" },
        {key: "America/Inuvik", value: "America/Inuvik" },
        {key: "America/Mazatlan", value: "America/Mazatlan" },
        {key: "America/Phoenix", value: "America/Phoenix" },
        {key: "America/Shiprock", value: "America/Shiprock" },
        {key: "America/Yellowknife", value: "America/Yellowknife" },
        {key: "Canada/Mountain", value: "Canada/Mountain" },
        {key: "Etc/GMT+7", value: "Etc/GMT+7" },
        {key: "MST", value: "MST" },
        {key: "MST7MDT", value: "MST7MDT" },
        {key: "Mexico/BajaSur", value: "Mexico/BajaSur" },
        {key: "Navajo", value: "Navajo" },
        {key: "PNT", value: "PNT" },
        {key: "SystemV/MST7", value: "SystemV/MST7" },
        {key: "SystemV/MST7MDT", value: "SystemV/MST7MDT" },
        {key: "US/Arizona", value: "US/Arizona" },
        {key: "US/Mountain", value: "US/Mountain" },
        {key: "America/Belize", value: "America/Belize" },
        {key: "America/Cancun", value: "America/Cancun" },
        {key: "America/Chicago", value: "America/Chicago" },
        {key: "America/Costa_Rica", value: "America/Costa_Rica" },
        {key: "America/El_Salvador", value: "America/El_Salvador" },
        {key: "America/Guatemala", value: "America/Guatemala" },
        {key: "America/Managua", value: "America/Managua" },
        {key: "America/Menominee", value: "America/Menominee" },
        {key: "America/Merida", value: "America/Merida" },
        {key: "America/Mexico_City", value: "America/Mexico_City" },
        {key: "America/Monterrey", value: "America/Monterrey" },
        {key: "America/North_Dakota/Center", value: "America/North_Dakota/Center" },
        {key: "America/Rainy_River", value: "America/Rainy_River" },
        {key: "America/Rankin_Inlet", value: "America/Rankin_Inlet" },
        {key: "America/Regina", value: "America/Regina" },
        {key: "America/Swift_Current", value: "America/Swift_Current" },
        {key: "America/Tegucigalpa", value: "America/Tegucigalpa" },
        {key: "America/Winnipeg", value: "America/Winnipeg" },
        {key: "CST", value: "CST" },
        {key: "CST6CDT", value: "CST6CDT" },
        {key: "Canada/Central", value: "Canada/Central" },
        {key: "Canada/East-Saskatchewan", value: "Canada/East-Saskatchewan" },
        {key: "Canada/Saskatchewan", value: "Canada/Saskatchewan" },
        {key: "Chile/EasterIsland", value: "Chile/EasterIsland" },
        {key: "Etc/GMT+6", value: "Etc/GMT+6" },
        {key: "Mexico/General", value: "Mexico/General" },
        {key: "Pacific/Easter", value: "Pacific/Easter" },
        {key: "Pacific/Galapagos", value: "Pacific/Galapagos" },
        {key: "SystemV/CST6", value: "SystemV/CST6" },
        {key: "SystemV/CST6CDT", value: "SystemV/CST6CDT" },
        {key: "US/Central", value: "US/Central" },
        {key: "America/Bogota", value: "America/Bogota" },
        {key: "America/Cayman", value: "America/Cayman" },
        {key: "America/Detroit", value: "America/Detroit" },
        {key: "America/Eirunepe", value: "America/Eirunepe" },
        {key: "America/Fort_Wayne", value: "America/Fort_Wayne" },
        {key: "America/Grand_Turk", value: "America/Grand_Turk" },
        {key: "America/Guayaquil", value: "America/Guayaquil" },
        {key: "America/Havana", value: "America/Havana" },
        {key: "America/Indiana/Indianapolis", value: "America/Indiana/Indianapolis" },
        {key: "America/Indiana/Knox", value: "America/Indiana/Knox" },
        {key: "America/Indiana/Marengo", value: "America/Indiana/Marengo" },
        {key: "America/Indiana/Vevay", value: "America/Indiana/Vevay" },
        {key: "America/Indianapolis", value: "America/Indianapolis" },
        {key: "America/Iqaluit", value: "America/Iqaluit" },
        {key: "America/Jamaica", value: "America/Jamaica" },
        {key: "America/Kentucky/Louisville", value: "America/Kentucky/Louisville" },
        {key: "America/Kentucky/Monticello", value: "America/Kentucky/Monticello" },
        {key: "America/Knox_IN", value: "America/Knox_IN" },
        {key: "America/Lima", value: "America/Lima" },
        {key: "America/Louisville", value: "America/Louisville" },
        {key: "America/Montreal", value: "America/Montreal" },
        {key: "America/Nassau", value: "America/Nassau" },
        {key: "America/New_York", value: "America/New_York" },
        {key: "America/Nipigon", value: "America/Nipigon" },
        {key: "America/Panama", value: "America/Panama" },
        {key: "America/Pangnirtung", value: "America/Pangnirtung" },
        {key: "America/Port-au-Prince", value: "America/Port-au-Prince" },
        {key: "America/Porto_Acre", value: "America/Porto_Acre" },
        {key: "America/Rio_Branco", value: "America/Rio_Branco" },
        {key: "America/Thunder_Bay", value: "America/Thunder_Bay" },
        {key: "America/Toronto", value: "America/Toronto" },
        {key: "Brazil/Acre", value: "Brazil/Acre" },
        {key: "Canada/Eastern", value: "Canada/Eastern" },
        {key: "Cuba", value: "Cuba" },
        {key: "EST", value: "EST" },
        {key: "EST5EDT", value: "EST5EDT" },
        {key: "Etc/GMT+5", value: "Etc/GMT+5" },
        {key: "IET", value: "IET" },
        {key: "Jamaica", value: "Jamaica" },
        {key: "SystemV/EST5", value: "SystemV/EST5" },
        {key: "SystemV/EST5EDT", value: "SystemV/EST5EDT" },
        {key: "US/East-Indiana", value: "US/East-Indiana" },
        {key: "US/Eastern", value: "US/Eastern" },
        {key: "US/Indiana-Starke", value: "US/Indiana-Starke" },
        {key: "US/Michigan", value: "US/Michigan" },
        {key: "America/Anguilla", value: "America/Anguilla" },
        {key: "America/Antigua", value: "America/Antigua" },
        {key: "America/Aruba", value: "America/Aruba" },
        {key: "America/Asuncion", value: "America/Asuncion" },
        {key: "America/Barbados", value: "America/Barbados" },
        {key: "America/Boa_Vista", value: "America/Boa_Vista" },
        {key: "America/Campo_Grande", value: "America/Campo_Grande" },
        {key: "America/Caracas", value: "America/Caracas" },
        {key: "America/Cuiaba", value: "America/Cuiaba" },
        {key: "America/Curacao", value: "America/Curacao" },
        {key: "America/Dominica", value: "America/Dominica" },
        {key: "America/Glace_Bay", value: "America/Glace_Bay" },
        {key: "America/Goose_Bay", value: "America/Goose_Bay" },
        {key: "America/Grenada", value: "America/Grenada" },
        {key: "America/Guadeloupe", value: "America/Guadeloupe" },
        {key: "America/Guyana", value: "America/Guyana" },
        {key: "America/Halifax", value: "America/Halifax" },
        {key: "America/La_Paz", value: "America/La_Paz" },
        {key: "America/Manaus", value: "America/Manaus" },
        {key: "America/Martinique", value: "America/Martinique" },
        {key: "America/Montserrat", value: "America/Montserrat" },
        {key: "America/Port_of_Spain", value: "America/Port_of_Spain" },
        {key: "America/Porto_Velho", value: "America/Porto_Velho" },
        {key: "America/Puerto_Rico", value: "America/Puerto_Rico" },
        {key: "America/Santiago", value: "America/Santiago" },
        {key: "America/Santo_Domingo", value: "America/Santo_Domingo" },
        {key: "America/St_Kitts", value: "America/St_Kitts" },
        {key: "America/St_Lucia", value: "America/St_Lucia" },
        {key: "America/St_Thomas", value: "America/St_Thomas" },
        {key: "America/St_Vincent", value: "America/St_Vincent" },
        {key: "America/Thule", value: "America/Thule" },
        {key: "America/Tortola", value: "America/Tortola" },
        {key: "America/Virgin", value: "America/Virgin" },
        {key: "Antarctica/Palmer", value: "Antarctica/Palmer" },
        {key: "Atlantic/Bermuda", value: "Atlantic/Bermuda" },
        {key: "Atlantic/Stanley", value: "Atlantic/Stanley" },
        {key: "Brazil/West", value: "Brazil/West" },
        {key: "Canada/Atlantic", value: "Canada/Atlantic" },
        {key: "Chile/Continental", value: "Chile/Continental" },
        {key: "Etc/GMT+4", value: "Etc/GMT+4" },
        {key: "PRT", value: "PRT" },
        {key: "SystemV/AST4", value: "SystemV/AST4" },
        {key: "SystemV/AST4ADT", value: "SystemV/AST4ADT" },
        {key: "America/St_Johns", value: "America/St_Johns" },
        {key: "CNT", value: "CNT" },
        {key: "Canada/Newfoundland", value: "Canada/Newfoundland" },
        {key: "AGT", value: "AGT" },
        {key: "America/Araguaina", value: "America/Araguaina" },
        {key: "America/Bahia", value: "America/Bahia" },
        {key: "America/Belem", value: "America/Belem" },
        {key: "America/Buenos_Aires", value: "America/Buenos_Aires" },
        {key: "America/Catamarca", value: "America/Catamarca" },
        {key: "America/Cayenne", value: "America/Cayenne" },
        {key: "America/Cordoba", value: "America/Cordoba" },
        {key: "America/Fortaleza", value: "America/Fortaleza" },
        {key: "America/Godthab", value: "America/Godthab" },
        {key: "America/Jujuy", value: "America/Jujuy" },
        {key: "America/Maceio", value: "America/Maceio" },
        {key: "America/Mendoza", value: "America/Mendoza" },
        {key: "America/Miquelon", value: "America/Miquelon" },
        {key: "America/Montevideo", value: "America/Montevideo" },
        {key: "America/Paramaribo", value: "America/Paramaribo" },
        {key: "America/Recife", value: "America/Recife" },
        {key: "America/Rosario", value: "America/Rosario" },
        {key: "America/Sao_Paulo", value: "America/Sao_Paulo" },
        {key: "Antarctica/Rothera", value: "Antarctica/Rothera" },
        {key: "BET", value: "BET" },
        {key: "Brazil/East", value: "Brazil/East" },
        {key: "Etc/GMT+3", value: "Etc/GMT+3" },
        {key: "America/Noronha", value: "America/Noronha" },
        {key: "Atlantic/South_Georgia", value: "Atlantic/South_Georgia" },
        {key: "Brazil/DeNoronha", value: "Brazil/DeNoronha" },
        {key: "Etc/GMT+2", value: "Etc/GMT+2" },
        {key: "America/Scoresbysund", value: "America/Scoresbysund" },
        {key: "Atlantic/Azores", value: "Atlantic/Azores" },
        {key: "Atlantic/Cape_Verde", value: "Atlantic/Cape_Verde" },
        {key: "Etc/GMT+1", value: "Etc/GMT+1" },
        {key: "Africa/Abidjan", value: "Africa/Abidjan" },
        {key: "Africa/Accra", value: "Africa/Accra" },
        {key: "Africa/Bamako", value: "Africa/Bamako" },
        {key: "Africa/Banjul", value: "Africa/Banjul" },
        {key: "Africa/Bissau", value: "Africa/Bissau" },
        {key: "Africa/Casablanca", value: "Africa/Casablanca" },
        {key: "Africa/Conakry", value: "Africa/Conakry" },
        {key: "Africa/Dakar", value: "Africa/Dakar" },
        {key: "Africa/El_Aaiun", value: "Africa/El_Aaiun" },
        {key: "Africa/Freetown", value: "Africa/Freetown" },
        {key: "Africa/Lome", value: "Africa/Lome" },
        {key: "Africa/Monrovia", value: "Africa/Monrovia" },
        {key: "Africa/Nouakchott", value: "Africa/Nouakchott" },
        {key: "Africa/Ouagadougou", value: "Africa/Ouagadougou" },
        {key: "Africa/Sao_Tome", value: "Africa/Sao_Tome" },
        {key: "Africa/Timbuktu", value: "Africa/Timbuktu" },
        {key: "America/Danmarkshavn", value: "America/Danmarkshavn" },
        {key: "Atlantic/Canary", value: "Atlantic/Canary" },
        {key: "Atlantic/Faeroe", value: "Atlantic/Faeroe" },
        {key: "Atlantic/Madeira", value: "Atlantic/Madeira" },
        {key: "Atlantic/Reykjavik", value: "Atlantic/Reykjavik" },
        {key: "Atlantic/St_Helena", value: "Atlantic/St_Helena" },
        {key: "Eire", value: "Eire" },
        {key: "Etc/GMT", value: "Etc/GMT" },
        {key: "Etc/GMT+0", value: "Etc/GMT+0" },
        {key: "Etc/GMT-0", value: "Etc/GMT-0" },
        {key: "Etc/GMT0", value: "Etc/GMT0" },
        {key: "Etc/Greenwich", value: "Etc/Greenwich" },
        {key: "Etc/UCT", value: "Etc/UCT" },
        {key: "Etc/UTC", value: "Etc/UTC" },
        {key: "Etc/Universal", value: "Etc/Universal" },
        {key: "Etc/Zulu", value: "Etc/Zulu" },
        {key: "Europe/Belfast", value: "Europe/Belfast" },
        {key: "Europe/Dublin", value: "Europe/Dublin" },
        {key: "Europe/Lisbon", value: "Europe/Lisbon" },
        {key: "Europe/London", value: "Europe/London" },
        {key: "GB", value: "GB" },
        {key: "GB-Eire", value: "GB-Eire" },
        {key: "GMT", value: "GMT" },
        {key: "GMT0", value: "GMT0" },
        {key: "Greenwich", value: "Greenwich" },
        {key: "Iceland", value: "Iceland" },
        {key: "Portugal", value: "Portugal" },
        {key: "UCT", value: "UCT" },
        {key: "UTC", value: "UTC" },
        {key: "Universal", value: "Universal" },
        {key: "WET", value: "WET" },
        {key: "Zulu", value: "Zulu" },
        {key: "Africa/Algiers", value: "Africa/Algiers" },
        {key: "Africa/Bangui", value: "Africa/Bangui" },
        {key: "Africa/Brazzaville", value: "Africa/Brazzaville" },
        {key: "Africa/Ceuta", value: "Africa/Ceuta" },
        {key: "Africa/Douala", value: "Africa/Douala" },
        {key: "Africa/Kinshasa", value: "Africa/Kinshasa" },
        {key: "Africa/Lagos", value: "Africa/Lagos" },
        {key: "Africa/Libreville", value: "Africa/Libreville" },
        {key: "Africa/Luanda", value: "Africa/Luanda" },
        {key: "Africa/Malabo", value: "Africa/Malabo" },
        {key: "Africa/Ndjamena", value: "Africa/Ndjamena" },
        {key: "Africa/Niamey", value: "Africa/Niamey" },
        {key: "Africa/Porto-Novo", value: "Africa/Porto-Novo" },
        {key: "Africa/Tunis", value: "Africa/Tunis" },
        {key: "Africa/Windhoek", value: "Africa/Windhoek" },
        {key: "Arctic/Longyearbyen", value: "Arctic/Longyearbyen" },
        {key: "Atlantic/Jan_Mayen", value: "Atlantic/Jan_Mayen" },
        {key: "CET", value: "CET" },
        {key: "ECT", value: "ECT" },
        {key: "Etc/GMT-1", value: "Etc/GMT-1" },
        {key: "Europe/Amsterdam", value: "Europe/Amsterdam" },
        {key: "Europe/Andorra", value: "Europe/Andorra" },
        {key: "Europe/Belgrade", value: "Europe/Belgrade" },
        {key: "Europe/Berlin", value: "Europe/Berlin" },
        {key: "Europe/Bratislava", value: "Europe/Bratislava" },
        {key: "Europe/Brussels", value: "Europe/Brussels" },
        {key: "Europe/Budapest", value: "Europe/Budapest" },
        {key: "Europe/Copenhagen", value: "Europe/Copenhagen" },
        {key: "Europe/Gibraltar", value: "Europe/Gibraltar" },
        {key: "Europe/Ljubljana", value: "Europe/Ljubljana" },
        {key: "Europe/Luxembourg", value: "Europe/Luxembourg" },
        {key: "Europe/Madrid", value: "Europe/Madrid" },
        {key: "Europe/Malta", value: "Europe/Malta" },
        {key: "Europe/Monaco", value: "Europe/Monaco" },
        {key: "Europe/Oslo", value: "Europe/Oslo" },
        {key: "Europe/Paris", value: "Europe/Paris" },
        {key: "Europe/Prague", value: "Europe/Prague" },
        {key: "Europe/Rome", value: "Europe/Rome" },
        {key: "Europe/San_Marino", value: "Europe/San_Marino" },
        {key: "Europe/Sarajevo", value: "Europe/Sarajevo" },
        {key: "Europe/Skopje", value: "Europe/Skopje" },
        {key: "Europe/Stockholm", value: "Europe/Stockholm" },
        {key: "Europe/Tirane", value: "Europe/Tirane" },
        {key: "Europe/Vaduz", value: "Europe/Vaduz" },
        {key: "Europe/Vatican", value: "Europe/Vatican" },
        {key: "Europe/Vienna", value: "Europe/Vienna" },
        {key: "Europe/Warsaw", value: "Europe/Warsaw" },
        {key: "Europe/Zagreb", value: "Europe/Zagreb" },
        {key: "Europe/Zurich", value: "Europe/Zurich" },
        {key: "MET", value: "MET" },
        {key: "Poland", value: "Poland" },
        {key: "ART", value: "ART" },
        {key: "Africa/Blantyre", value: "Africa/Blantyre" },
        {key: "Africa/Bujumbura", value: "Africa/Bujumbura" },
        {key: "Africa/Cairo", value: "Africa/Cairo" },
        {key: "Africa/Gaborone", value: "Africa/Gaborone" },
        {key: "Africa/Harare", value: "Africa/Harare" },
        {key: "Africa/Johannesburg", value: "Africa/Johannesburg" },
        {key: "Africa/Kigali", value: "Africa/Kigali" },
        {key: "Africa/Lubumbashi", value: "Africa/Lubumbashi" },
        {key: "Africa/Lusaka", value: "Africa/Lusaka" },
        {key: "Africa/Maputo", value: "Africa/Maputo" },
        {key: "Africa/Maseru", value: "Africa/Maseru" },
        {key: "Africa/Mbabane", value: "Africa/Mbabane" },
        {key: "Africa/Tripoli", value: "Africa/Tripoli" },
        {key: "Asia/Amman", value: "Asia/Amman" },
        {key: "Asia/Beirut", value: "Asia/Beirut" },
        {key: "Asia/Damascus", value: "Asia/Damascus" },
        {key: "Asia/Gaza", value: "Asia/Gaza" },
        {key: "Asia/Istanbul", value: "Asia/Istanbul" },
        {key: "Asia/Jerusalem", value: "Asia/Jerusalem" },
        {key: "Asia/Nicosia", value: "Asia/Nicosia" },
        {key: "Asia/Tel_Aviv", value: "Asia/Tel_Aviv" },
        {key: "CAT", value: "CAT" },
        {key: "EET", value: "EET" },
        {key: "Egypt", value: "Egypt" },
        {key: "Etc/GMT-2", value: "Etc/GMT-2" },
        {key: "Europe/Athens", value: "Europe/Athens" },
        {key: "Europe/Bucharest", value: "Europe/Bucharest" },
        {key: "Europe/Chisinau", value: "Europe/Chisinau" },
        {key: "Europe/Helsinki", value: "Europe/Helsinki" },
        {key: "Europe/Istanbul", value: "Europe/Istanbul" },
        {key: "Europe/Kaliningrad", value: "Europe/Kaliningrad" },
        {key: "Europe/Kiev", value: "Europe/Kiev" },
        {key: "Europe/Minsk", value: "Europe/Minsk" },
        {key: "Europe/Nicosia", value: "Europe/Nicosia" },
        {key: "Europe/Riga", value: "Europe/Riga" },
        {key: "Europe/Simferopol", value: "Europe/Simferopol" },
        {key: "Europe/Sofia", value: "Europe/Sofia" },
        {key: "Europe/Tallinn", value: "Europe/Tallinn" },
        {key: "Europe/Tiraspol", value: "Europe/Tiraspol" },
        {key: "Europe/Uzhgorod", value: "Europe/Uzhgorod" },
        {key: "Europe/Vilnius", value: "Europe/Vilnius" },
        {key: "Europe/Zaporozhye", value: "Europe/Zaporozhye" },
        {key: "Israel", value: "Israel" },
        {key: "Libya", value: "Libya" },
        {key: "Turkey", value: "Turkey" },
        {key: "Africa/Addis_Ababa", value: "Africa/Addis_Ababa" },
        {key: "Africa/Asmera", value: "Africa/Asmera" },
        {key: "Africa/Dar_es_Salaam", value: "Africa/Dar_es_Salaam" },
        {key: "Africa/Djibouti", value: "Africa/Djibouti" },
        {key: "Africa/Kampala", value: "Africa/Kampala" },
        {key: "Africa/Khartoum", value: "Africa/Khartoum" },
        {key: "Africa/Mogadishu", value: "Africa/Mogadishu" },
        {key: "Africa/Nairobi", value: "Africa/Nairobi" },
        {key: "Antarctica/Syowa", value: "Antarctica/Syowa" },
        {key: "Asia/Aden", value: "Asia/Aden" },
        {key: "Asia/Baghdad", value: "Asia/Baghdad" },
        {key: "Asia/Bahrain", value: "Asia/Bahrain" },
        {key: "Asia/Kuwait", value: "Asia/Kuwait" },
        {key: "Asia/Qatar", value: "Asia/Qatar" },
        {key: "Asia/Riyadh", value: "Asia/Riyadh" },
        {key: "EAT", value: "EAT" },
        {key: "Etc/GMT-3", value: "Etc/GMT-3" },
        {key: "Europe/Moscow", value: "Europe/Moscow" },
        {key: "Indian/Antananarivo", value: "Indian/Antananarivo" },
        {key: "Indian/Comoro", value: "Indian/Comoro" },
        {key: "Indian/Mayotte", value: "Indian/Mayotte" },
        {key: "W-SU", value: "W-SU" },
        {key: "Asia/Riyadh87", value: "Asia/Riyadh87" },
        {key: "Asia/Riyadh88", value: "Asia/Riyadh88" },
        {key: "Asia/Riyadh89", value: "Asia/Riyadh89" },
        {key: "Mideast/Riyadh87", value: "Mideast/Riyadh87" },
        {key: "Mideast/Riyadh88", value: "Mideast/Riyadh88" },
        {key: "Mideast/Riyadh89", value: "Mideast/Riyadh89" },
        {key: "Asia/Tehran", value: "Asia/Tehran" },
        {key: "Iran", value: "Iran" },
        {key: "Asia/Aqtau", value: "Asia/Aqtau" },
        {key: "Asia/Baku", value: "Asia/Baku" },
        {key: "Asia/Dubai", value: "Asia/Dubai" },
        {key: "Asia/Muscat", value: "Asia/Muscat" },
        {key: "Asia/Oral", value: "Asia/Oral" },
        {key: "Asia/Tbilisi", value: "Asia/Tbilisi" },
        {key: "Asia/Yerevan", value: "Asia/Yerevan" },
        {key: "Etc/GMT-4", value: "Etc/GMT-4" },
        {key: "Europe/Samara", value: "Europe/Samara" },
        {key: "Indian/Mahe", value: "Indian/Mahe" },
        {key: "Indian/Mauritius", value: "Indian/Mauritius" },
        {key: "Indian/Reunion", value: "Indian/Reunion" },
        {key: "NET", value: "NET" },
        {key: "Asia/Kabul", value: "Asia/Kabul" },
        {key: "Asia/Aqtobe", value: "Asia/Aqtobe" },
        {key: "Asia/Ashgabat", value: "Asia/Ashgabat" },
        {key: "Asia/Ashkhabad", value: "Asia/Ashkhabad" },
        {key: "Asia/Bishkek", value: "Asia/Bishkek" },
        {key: "Asia/Dushanbe", value: "Asia/Dushanbe" },
        {key: "Asia/Karachi", value: "Asia/Karachi" },
        {key: "Asia/Samarkand", value: "Asia/Samarkand" },
        {key: "Asia/Tashkent", value: "Asia/Tashkent" },
        {key: "Asia/Yekaterinburg", value: "Asia/Yekaterinburg" },
        {key: "Etc/GMT-5", value: "Etc/GMT-5" },
        {key: "Indian/Kerguelen", value: "Indian/Kerguelen" },
        {key: "Indian/Maldives", value: "Indian/Maldives" },
        {key: "PLT", value: "PLT" },
        {key: "Asia/Calcutta", value: "Asia/Calcutta" },
        {key: "IST", value: "IST" },
        {key: "Asia/Katmandu", value: "Asia/Katmandu" },
        {key: "Antarctica/Mawson", value: "Antarctica/Mawson" },
        {key: "Antarctica/Vostok", value: "Antarctica/Vostok" },
        {key: "Asia/Almaty", value: "Asia/Almaty" },
        {key: "Asia/Colombo", value: "Asia/Colombo" },
        {key: "Asia/Dacca", value: "Asia/Dacca" },
        {key: "Asia/Dhaka", value: "Asia/Dhaka" },
        {key: "Asia/Novosibirsk", value: "Asia/Novosibirsk" },
        {key: "Asia/Omsk", value: "Asia/Omsk" },
        {key: "Asia/Qyzylorda", value: "Asia/Qyzylorda" },
        {key: "Asia/Thimbu", value: "Asia/Thimbu" },
        {key: "Asia/Thimphu", value: "Asia/Thimphu" },
        {key: "BST", value: "BST" },
        {key: "Etc/GMT-6", value: "Etc/GMT-6" },
        {key: "Indian/Chagos", value: "Indian/Chagos" },
        {key: "Asia/Rangoon", value: "Asia/Rangoon" },
        {key: "Indian/Cocos", value: "Indian/Cocos" },
        {key: "Antarctica/Davis", value: "Antarctica/Davis" },
        {key: "Asia/Bangkok", value: "Asia/Bangkok" },
        {key: "Asia/Hovd", value: "Asia/Hovd" },
        {key: "Asia/Jakarta", value: "Asia/Jakarta" },
        {key: "Asia/Krasnoyarsk", value: "Asia/Krasnoyarsk" },
        {key: "Asia/Phnom_Penh", value: "Asia/Phnom_Penh" },
        {key: "Asia/Pontianak", value: "Asia/Pontianak" },
        {key: "Asia/Saigon", value: "Asia/Saigon" },
        {key: "Asia/Vientiane", value: "Asia/Vientiane" },
        {key: "Etc/GMT-7", value: "Etc/GMT-7" },
        {key: "Indian/Christmas", value: "Indian/Christmas" },
        {key: "VST", value: "VST" },
        {key: "Antarctica/Casey", value: "Antarctica/Casey" },
        {key: "Asia/Brunei", value: "Asia/Brunei" },
        {key: "Asia/Chongqing", value: "Asia/Chongqing" },
        {key: "Asia/Chungking", value: "Asia/Chungking" },
        {key: "Asia/Harbin", value: "Asia/Harbin" },
        {key: "Asia/Hong_Kong", value: "Asia/Hong_Kong" },
        {key: "Asia/Irkutsk", value: "Asia/Irkutsk" },
        {key: "Asia/Kashgar", value: "Asia/Kashgar" },
        {key: "Asia/Kuala_Lumpur", value: "Asia/Kuala_Lumpur" },
        {key: "Asia/Kuching", value: "Asia/Kuching" },
        {key: "Asia/Macao", value: "Asia/Macao" },
        {key: "Asia/Macau", value: "Asia/Macau" },
        {key: "Asia/Makassar", value: "Asia/Makassar" },
        {key: "Asia/Manila", value: "Asia/Manila" },
        {key: "Asia/Shanghai", value: "Asia/Shanghai" },
        {key: "Asia/Singapore", value: "Asia/Singapore" },
        {key: "Asia/Taipei", value: "Asia/Taipei" },
        {key: "Asia/Ujung_Pandang", value: "Asia/Ujung_Pandang" },
        {key: "Asia/Ulaanbaatar", value: "Asia/Ulaanbaatar" },
        {key: "Asia/Ulan_Bator", value: "Asia/Ulan_Bator" },
        {key: "Asia/Urumqi", value: "Asia/Urumqi" },
        {key: "Australia/Perth", value: "Australia/Perth" },
        {key: "Australia/West", value: "Australia/West" },
        {key: "CTT", value: "CTT" },
        {key: "Etc/GMT-8", value: "Etc/GMT-8" },
        {key: "Hongkong", value: "Hongkong" },
        {key: "PRC", value: "PRC" },
        {key: "Singapore", value: "Singapore" },
        {key: "Asia/Choibalsan", value: "Asia/Choibalsan" },
        {key: "Asia/Dili", value: "Asia/Dili" },
        {key: "Asia/Jayapura", value: "Asia/Jayapura" },
        {key: "Asia/Pyongyang", value: "Asia/Pyongyang" },
        {key: "Asia/Seoul", value: "Asia/Seoul" },
        {key: "Asia/Tokyo", value: "Asia/Tokyo" },
        {key: "Asia/Yakutsk", value: "Asia/Yakutsk" },
        {key: "Etc/GMT-9", value: "Etc/GMT-9" },
        {key: "JST", value: "JST" },
        {key: "Japan", value: "Japan" },
        {key: "Pacific/Palau", value: "Pacific/Palau" },
        {key: "ROK", value: "ROK" },
        {key: "ACT", value: "ACT" },
        {key: "Australia/Adelaide", value: "Australia/Adelaide" },
        {key: "Australia/Broken_Hill", value: "Australia/Broken_Hill" },
        {key: "Australia/Darwin", value: "Australia/Darwin" },
        {key: "Australia/North", value: "Australia/North" },
        {key: "Australia/South", value: "Australia/South" },
        {key: "Australia/Yancowinna", value: "Australia/Yancowinna" },
        {key: "AET", value: "AET" },
        {key: "Antarctica/DumontDUrville", value: "Antarctica/DumontDUrville" },
        {key: "Asia/Sakhalin", value: "Asia/Sakhalin" },
        {key: "Asia/Vladivostok", value: "Asia/Vladivostok" },
        {key: "Australia/ACT", value: "Australia/ACT" },
        {key: "Australia/Brisbane", value: "Australia/Brisbane" },
        {key: "Australia/Canberra", value: "Australia/Canberra" },
        {key: "Australia/Hobart", value: "Australia/Hobart" },
        {key: "Australia/Lindeman", value: "Australia/Lindeman" },
        {key: "Australia/Melbourne", value: "Australia/Melbourne" },
        {key: "Australia/NSW", value: "Australia/NSW" },
        {key: "Australia/Queensland", value: "Australia/Queensland" },
        {key: "Australia/Sydney", value: "Australia/Sydney" },
        {key: "Australia/Tasmania", value: "Australia/Tasmania" },
        {key: "Australia/Victoria", value: "Australia/Victoria" },
        {key: "Etc/GMT-10", value: "Etc/GMT-10" },
        {key: "Pacific/Guam", value: "Pacific/Guam" },
        {key: "Pacific/Port_Moresby", value: "Pacific/Port_Moresby" },
        {key: "Pacific/Saipan", value: "Pacific/Saipan" },
        {key: "Pacific/Truk", value: "Pacific/Truk" },
        {key: "Pacific/Yap", value: "Pacific/Yap" },
        {key: "Australia/LHI", value: "Australia/LHI" },
        {key: "Australia/Lord_Howe", value: "Australia/Lord_Howe" },
        {key: "Asia/Magadan", value: "Asia/Magadan" },
        {key: "Etc/GMT-11", value: "Etc/GMT-11" },
        {key: "Pacific/Efate", value: "Pacific/Efate" },
        {key: "Pacific/Guadalcanal", value: "Pacific/Guadalcanal" },
        {key: "Pacific/Kosrae", value: "Pacific/Kosrae" },
        {key: "Pacific/Noumea", value: "Pacific/Noumea" },
        {key: "Pacific/Ponape", value: "Pacific/Ponape" },
        {key: "SST", value: "SST" },
        {key: "Pacific/Norfolk", value: "Pacific/Norfolk" },
        {key: "Antarctica/McMurdo", value: "Antarctica/McMurdo" },
        {key: "Antarctica/South_Pole", value: "Antarctica/South_Pole" },
        {key: "Asia/Anadyr", value: "Asia/Anadyr" },
        {key: "Asia/Kamchatka", value: "Asia/Kamchatka" },
        {key: "Etc/GMT-12", value: "Etc/GMT-12" },
        {key: "Kwajalein", value: "Kwajalein" },
        {key: "NST", value: "NST" },
        {key: "NZ", value: "NZ" },
        {key: "Pacific/Auckland", value: "Pacific/Auckland" },
        {key: "Pacific/Fiji", value: "Pacific/Fiji" },
        {key: "Pacific/Funafuti", value: "Pacific/Funafuti" },
        {key: "Pacific/Kwajalein", value: "Pacific/Kwajalein" },
        {key: "Pacific/Majuro", value: "Pacific/Majuro" },
        {key: "Pacific/Nauru", value: "Pacific/Nauru" },
        {key: "Pacific/Tarawa", value: "Pacific/Tarawa" },
        {key: "Pacific/Wake", value: "Pacific/Wake" },
        {key: "Pacific/Wallis", value: "Pacific/Wallis" },
        {key: "NZ-CHAT", value: "NZ-CHAT" },
        {key: "Pacific/Chatham", value: "Pacific/Chatham" },
        {key: "Etc/GMT-13", value: "Etc/GMT-13" },
        {key: "Pacific/Enderbury", value: "Pacific/Enderbury" },
        {key: "Pacific/Tongatapu", value: "Pacific/Tongatapu" },
        {key: "Etc/GMT-14", value: "Etc/GMT-14" },
        {key: "Pacific/Kiritimati", value: "Pacific/Kiritimati"
        }
    ];


    static isScreenAvailable = (scrName:string):boolean=>{
        let flag:boolean = false;
        if(CommonUtil.PERMISSION_DATA){for(let idx:number = 0;idx<CommonUtil.PERMISSION_DATA.length;idx++){    let pItem = CommonUtil.PERMISSION_DATA[idx];
                if(pItem && (pItem.addPermission || pItem.editPermission)){        if(pItem.screenName == scrName){            return true;
                    }
                }
            }
        }
        return flag;
    }

    static isScreenButtonAvailable = (scrName:string,btn:string):boolean=>{
        let flag:boolean = false;
        if(CommonUtil.PERMISSION_DATA){for(let idx:number = 0;idx<CommonUtil.PERMISSION_DATA.length;idx++){    let pItem = CommonUtil.PERMISSION_DATA[idx];
                if(pItem && (pItem.addPermission || pItem.editPermission)){        if(pItem.screenName == scrName){            if(btn == CommonUtil.UPDATE_MODE && pItem.editPermission){                return true;
                        }
                    }
                }
            }
        }
        return flag;
    }

    // static getIDToken = ()=>{
    //     for (var x1 in sessionStorage){var obj = sessionStorage[x1];
    //         if(obj){    try{        var obj1 = JSON.parse(obj);
    //                 if(obj1 && obj1.credentialType == "IdToken"){
    //                     sessionStorage.setItem("idtkn",obj1.secret);
    //                 }
    //             }catch(ex){}
    //         }
    //     }
    // }


    static sessionKey = "";
    static getIDToken = () => {
        for (let key in sessionStorage) {
            if (!Object.prototype.hasOwnProperty.call(sessionStorage, key)) continue;

            const rawData = sessionStorage.getItem(key);
            if (!rawData) continue;

            try {
                const parsed = JSON.parse(rawData);

                if (parsed && parsed.credentialType === "IdToken" && typeof parsed.secret === "string") {
                    // Optional: basic JWT format check
                    if (/^[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+\.[A-Za-z0-9-_]+$/.test(parsed.secret)) {
                        CommonUtil.sessionKey = parsed.secret; // ✅ store in memory, not in storage
                        break; // stop scanning once found
                    }
                }
            } catch (ex) {}
        }
    };
}
export default CommonUtil;
